import { useLazyQuery } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  DATE_FORMATS,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
} from '../../../../../common/constants';
import { formatDate, hasPermission } from '../../../../../common/utils';
import GoBackButton from '../../../../../components/GoBackButton';
import LoaderComponent from '../../../../../components/LoaderComponent';
import Portal from '../../../../../components/Portal';
import { USER } from '../../../graphql/Queries';
import AmbassadorForm from '../components/AmbassadorForm';

const ViewAmbassador = (props) => {
  const { match: { params: { id } = {} } = {} } = props;
  const {
    state: { permissions },
  } = useContext(AppContext);

  const [form] = Form.useForm();
  const history = useHistory();
  const [ambassadorDetail, setAmbassadorDetail] = useState({});
  const [isAmbassadorLoading, setIsAmbassadorLoading] = useState(true);

  const [users] = useLazyQuery(USER, {
    onCompleted: (response) => {
      setAmbassadorDetail(response?.user);
      setIsAmbassadorLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {},
  });

  useEffect(() => {
    setIsAmbassadorLoading(true);
    setAmbassadorDetail([]);
    users({
      variables: {
        where: {
          id,
        },
      },
    });
  }, []);

  const initialValues = {
    ...ambassadorDetail,
    name: `${ambassadorDetail?.firstName || ''} ${ambassadorDetail?.lastName || ''}`.trim(),
    contact: ambassadorDetail?.contactNo,
    role: ambassadorDetail?.roles?.[0],
    gender: ambassadorDetail?.gender,
    status: ambassadorDetail?.isActive,
    state: ambassadorDetail?.state,
    city: ambassadorDetail?.city,
    address: ambassadorDetail?.address,
    landmark: ambassadorDetail?.landmark,
    pincode: ambassadorDetail?.pincode?.pincode,
    isActive: ambassadorDetail?.status,
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton customLink={ROUTES?.SYSTEM_USERS} />
        <div className="portal-header">View Ambassador</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS,
          PERMISSION_TYPE?.UPDATE,
          permissions,
        ) && (
          <div className="header-btn-wrapper">
            <Button
              className="common-button mr-16"
              size="middle"
              onClick={() =>
                history?.push(
                  `${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}/edit/${id}`,
                )
              }
              disabled={ambassadorDetail?.isArchived}
            >
              Edit Ambassador
            </Button>
          </div>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS,
          PERMISSION_TYPE?.UPDATE,
          permissions,
        ) && (
          <div className="header-btn-wrapper">
            <Button
              className="common-button mr-16"
              size="middle"
              onClick={() =>
                history?.push(
                  `${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}/edit/${id}`,
                )
              }
              disabled={ambassadorDetail?.isArchived}
            >
              Edit Ambassador
            </Button>
          </div>
        )}
      </Portal>
      <Card
        className="full-height-with-nav"
        title="Ambassador Details"
        extra={
          <strong>
            Onboarded On :{' '}
            {formatDate(ambassadorDetail?.createdAt, DATE_FORMATS?.ONBOARD)}
          </strong>
        }
      >
        {isAmbassadorLoading ? (
          <LoaderComponent
            size="large"
            setHeight="60"
            spinning={isAmbassadorLoading}
          />
        ) : (
          <div className="admin-form">
            <AmbassadorForm
              form={form}
              initialValues={initialValues}
              isView
              ambassadorDetail={ambassadorDetail}
            />
          </div>
        )}
      </Card>
    </>
  );
};

export default ViewAmbassador;
